import { Component, Input, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcLabsProvidersListItemDto, FormGroupValidationRules } from 'webcommon/shared';

import { FcItemModalContext } from '../../../models';
import { FcItemListBaseComponent, FcListValidationService } from '../../generic';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'ap-fc-labs-providers-list',
  templateUrl: './fc-labs-providers-list.component.html',
  styleUrls: ['./fc-labs-providers-list.component.less'],
})
export class FcLabsProvidersListComponent extends FcItemListBaseComponent implements OnChanges {
  @Input() baseId: string;
  @Input() form: FormGroup;
  @Input() listItem: FcLabsProvidersListItemDto;
  @Input() isSubmitted = false;
  @Input() itemContext: FcItemModalContext;

  public isPreferredLaboratoriesFindControlRequired = false;
  public isNonParticipatingProvidersFindControlRequired = false;

  public preferredLaboratoriesPks: string[] = [];
  public nonParticipatingProvidersPks: string[] = [];

  public preferredLaboratoriesControl = new FormControl<string[]>([]);
  public nonParticipatingProvidersControl = new FormControl<string[]>([]);

  public listItemDefaultValidation: FormGroupValidationRules = {};

  constructor(injector: Injector) {
    super(injector);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.itemContext != null) {
      this.fcListValidation.initValidation(this.itemContext, {});
    }
    if (changes.form != null) {
      this.addControlsToForm();
    }
    if (changes.itemContext != null || changes.form != null || changes.listItem != null) {
      this.setForm();
    }
  }

  public addControlsToForm(): void {
    this.form.addControl('PreferredLaboratoriesUid', this.preferredLaboratoriesControl);
    this.form.addControl('RelInsuranceCarrierProviderExclusion', this.nonParticipatingProvidersControl);
  }

  private setForm(): void {
    this.preferredLaboratoriesPks = this.getFindControlValue(this.listItem?.PreferredLaboratoriesUid);
    this.nonParticipatingProvidersPks = this.getFindControlValue(this.listItem?.RelInsuranceCarrierProviderExclusion);
  }
}
